import { render, staticRenderFns } from "./ScoreLayout.vue?vue&type=template&id=40ccdd62&scoped=true&"
import script from "./ScoreLayout.vue?vue&type=script&lang=js&"
export * from "./ScoreLayout.vue?vue&type=script&lang=js&"
import style0 from "./ScoreLayout.vue?vue&type=style&index=0&id=40ccdd62&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ccdd62",
  null
  
)

export default component.exports